export default {
  state: {
    detail: null,
    urlQuery: null
  },
  mutations: {
    setLeaveDetail(state, payload) {
      state.detail = payload
    },
    setLeavePageQuery(state, payload) {
      state.urlQuery = payload
    }
  },
  actions: {},
  getters: {
    getLeaveDetail(state) {
      return state.detail
    },
    getLeavePageQuery(state) {
      return state.urlQuery
    }
  }
}
